import 'intersection-observer';
import * as $ from 'jquery';
import * as slick from 'slick-carousel';

import Nav from './modules/Nav';
import ImageScroll from './modules/ImageScroll';
import SlideAnimation from './modules/SlideAnimation';
import PopupAnimation from './modules/PopupAnimation';
import Accordian from './modules/Accordian';
import ScrollToTop from './modules/ScrollToTop';
import LazyLoad from './modules/LazyLoad';
import Slider from './modules/Slider';
import OriginStory from './modules/OriginStory';

// modules
var nav = new Nav();
var imageScroll = new ImageScroll();
var slideAnimation = new SlideAnimation();
var popupAnimation = new PopupAnimation();
var accordian = new Accordian();
var scrollToTop = new ScrollToTop();
var lazyload = new LazyLoad();
var slider = new Slider();
var originStory = new OriginStory();
